// product grid/list
function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function () {
      Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
      this.classList.add('active');
      if (this.classList.contains('listv')) {
        document.getElementById('product-grid')?.classList.add('product-list');
        document.getElementById('product-grid')?.classList.remove('product-grid');
      } else if (this.classList.contains('gridv')) {
        document.getElementById('product-grid')?.classList.add('product-grid');
        document.getElementById('product-grid')?.classList.remove('product-list');
      }
    });
  });
}
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if (document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i];
      if (thisVideoEl.closest('media-gallery')) continue;

      var videoHeight = thisVideoEl.clientHeight;
      var videoClientRect = thisVideoEl.getBoundingClientRect().top;

      if (videoClientRect <= ((windowHeight) - (videoHeight * .5)) && videoClientRect >= (0 - (videoHeight * .5))) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

/**
 * COUNTDOWN TIMER (timezone-safe)
 *
 * ✅ IMPORTANT:
 * In your section setting "wb_enddate", enter a timezone-aware value like:
 *   2026-02-13T23:59:00-08:00
 * (This is 11:59 PM Pacific Standard Time)
 *
 * If you do that, the countdown will be correct for everyone everywhere.
 */
document.addEventListener('DOMContentLoaded', () => {
  setInterval(countDown, 1000);
  countDown();

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function countDown() {
    const countCardSections = document.querySelectorAll('.countd_all');

    countCardSections.forEach((countdownSection) => {
      const daysElement = countdownSection.querySelector('.main_cdays .wb_cdays');
      const hoursElement = countdownSection.querySelector('.main_chours .wb_chours');
      const minutesElement = countdownSection.querySelector('.main_cminutes .wb_cminutes');
      const secondsElement = countdownSection.querySelector('.main_cseconds .wb_cseconds');
      const messageElement = countdownSection.querySelector('.main_ctext');

      const dateStr = countdownSection.getAttribute('data-date') || '';
      const end = new Date(dateStr);
      const endMs = end.getTime();

      // If the date is invalid, zero everything out (avoids NaN weirdness)
      if (!Number.isFinite(endMs)) {
        if (daysElement) daysElement.textContent = "00";
        if (hoursElement) hoursElement.textContent = "00";
        if (minutesElement) minutesElement.textContent = "00";
        if (secondsElement) secondsElement.textContent = "00";
        if (messageElement) messageElement.style.display = "block";
        return;
      }

      const now = Date.now();
      const distance = endMs - now;

      if (distance <= 0) {
        // Timer finished
        if (daysElement) daysElement.textContent = "00";
        if (hoursElement) hoursElement.textContent = "00";
        if (minutesElement) minutesElement.textContent = "00";
        if (secondsElement) secondsElement.textContent = "00";

        if (messageElement && messageElement.textContent.trim() !== '') {
          // Hide individual time blocks if you want the message only
          const dWrap = daysElement?.parentElement;
          const hWrap = hoursElement?.parentElement;
          const mWrap = minutesElement?.parentElement;
          const sWrap = secondsElement?.parentElement;

          if (dWrap) dWrap.style.display = "none";
          if (hWrap) hWrap.style.display = "none";
          if (mWrap) mWrap.style.display = "none";
          if (sWrap) sWrap.style.display = "none";

          countdownSection.style.display = "inline-block";
          messageElement.style.display = "block";
        }
        return;
      }

      // Update numbers
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysElement) daysElement.textContent = pad2(days);
      if (hoursElement) hoursElement.textContent = pad2(hours);
      if (minutesElement) minutesElement.textContent = pad2(minutes);
      if (secondsElement) secondsElement.textContent = pad2(seconds);

      if (messageElement) messageElement.style.display = "none";
    });
  }
});
